function initializeButtons() {
    // Select all buttons that need the animation
    const buttons = document.querySelectorAll([
      '.cta-button--primary a',
      '.cta-button--primary button',
      '.cta-button--primary-alternative a',
      '.cta-button--primary-alternative button',
      '.wp-block-button .wp-element-button',
      '.fulfilment-dropdown__cart-btn-wrapper a', // Added this selector specifically
      '.fulfilment-dropdown__cart-btn',  
      '#mc-embedded-subscribe'
    ].join(','));
    
    buttons.forEach(button => {
      // Skip if already initialized
      if (button.hasAttribute('data-animation-initialized')) {
        return;
      }
      
      // Get text content from either the button itself or a child .cta-button__text
      let buttonText = button.textContent.trim();
      const textElement = button.querySelector('.cta-button__text');
      
      if (textElement) {
        // If there's a .cta-button__text element, get its text or data-text attribute
        buttonText = textElement.getAttribute('data-text') || textElement.textContent.trim();
      }
      
      // Store the button text content for animation
      button.setAttribute('data-text', buttonText);
      
      // Set up hover listeners for animation
      button.addEventListener('mouseenter', function() {
        this.style.setProperty('--hover-state', '1');
      });
      
      button.addEventListener('mouseleave', function() {
        this.style.setProperty('--hover-state', '0');
      });
      
      // Mark as initialized
      button.setAttribute('data-animation-initialized', 'true');
    });
  }
  
  // Run on initial page load
  document.addEventListener('DOMContentLoaded', initializeButtons);
  
  // Run when AJAX content is loaded
  // Option 1: If you control the AJAX call
  function afterAjaxLoad() {
    initializeButtons();
  }
  
  // Option 2: If you don't control the AJAX call, use MutationObserver
  const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.addedNodes.length) {
        initializeButtons();
      }
    });
  });
  
  // Start observing the document body for DOM changes
  observer.observe(document.body, { childList: true, subtree: true });